import { Button, Dropdown, Menu, message, Switch, Tooltip, Modal } from "antd";
import ol from "openlayers";
import React from "react";
import {
  iconGeometry,
  Google_Layer_Ve_Tinh,
  Google_Layer_Ban_Do,
  iconStyle,
  KienTruc,
} from "../../../components/ListLayer";
import { AxiosGetSecretApi } from "../../../utils/fetchApi/index";
import "../MapQuyHoach/map-quy-hoach.scss";

class MapQuyHoach extends React.PureComponent {
  constructor(props) {
    super(props);
    this.map = {};
    this._layers = [];

    this.state = {
      checkedVeTinh: false,
      checkedBanDo: true,
    };

    this._vectorLayer = null;
    this._iconGeometry = iconGeometry;

    this.BaseLayer = {
      Google_Layer_Ve_Tinh: Google_Layer_Ve_Tinh,
      Google_Layer_Ban_Do: Google_Layer_Ban_Do,
      KienTruc: KienTruc,
    };
  }

  async componentDidMount() {
    window.onbeforeunload = null;
    this.initMap();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isShowMenu !== this.props.isShowMenu) {
      if (this.map) {
        setTimeout(() => {
          this.map.updateSize();
        }, 1);
      }
    }
  }

  async initMap() {
    let iconFeature = new ol.Feature({
      geometry: this._iconGeometry,
      name: "Null Island",
      population: 4000,
      rainfall: 500,
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new ol.source.Vector({
      features: [iconFeature],
    });

    let vectorLayer = new ol.layer.Vector({
      source: vectorSource,
    });
    vectorLayer.setZIndex(99);

    this.BaseLayer.vectorLayer = vectorLayer;

    this._layers.push(this.BaseLayer.Google_Layer_Ban_Do);
    this._layers.push(this.BaseLayer.Google_Layer_Ve_Tinh);
    this._layers.push(this.BaseLayer.KienTruc);
    this._layers.push(this.BaseLayer.vectorLayer);

    this.BaseLayer.KienTruc.setVisible(true);
    this.BaseLayer.Google_Layer_Ban_Do.setVisible(true);
    this.BaseLayer.vectorLayer.setVisible(false);

    this.map = new ol.Map({
      layers: [...this._layers],
      loadTilesWhileInteracting: true,
      target: "map",
      view: new ol.View({
        code: "EPSG:10775",
        center: [12045324.924720876, 1806357.9277613866],
        zoom: 14,
        minZoom: 6,
        maxZoom: 20,
      }),
      controls: ol.control.defaults({
        attribution: false,
        zoom: true,
      }),
    });
    // het ------------------------------------------------------------------------------------------------------------------

    this.map.on("singleclick", (evt) => {
      //   this.setLocation(evt.coordinate);
      let view = this.map.getView();
      let viewResolution = view.getResolution();

      let source = undefined;
      source = this.BaseLayer.KienTruc.getSource();

      if (source) {
        let url = source.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );
        this.searchDuAnByClick(url, evt);
      }
    });

    setTimeout(() => {
      this.map.updateSize();
    }, 1);
  }

  setLocation = (oo, zoom) => {
    this.map.getView().setCenter(oo);
    if (zoom) {
      this.map.getView().setZoom(zoom);
    }
    this._iconGeometry.setCoordinates(oo);
  };

  handleCloseClick = (e) => {
    this.BaseLayer.vectorLayer.setVisible(false);
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);
    // closer.blur();
  };

  async searchDuAnByClick(url, evt) {
    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties.OBJECTID
    ) {
      if (this.OBJECTID !== res.features[0].properties.OBJECTID) {
        this.OBJECTID = res.features[0].properties.OBJECTID;
        this.props.searchDataTable(this.OBJECTID);
        this.setLocation(evt.coordinate);
      }
    } else {
      message.error("Chưa có thông tin dự án (Dữ liệu đang cập nhật)");
    }
  }

  drawRing = (data) => {
    //draw line
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);
    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }

    // this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);

    if (data && data.length !== 0) {
      let listPoint = [];
      data.forEach((e) => {
        let x = new ol.Feature({
          geometry: new ol.geom.LineString(e),
        });
        listPoint.push(x);
      });

      let vectorSource = new ol.source.Vector({
        features: listPoint,
      });

      let aa = listPoint[0].getGeometry().getExtent();
      let oo = ol.extent.getCenter(aa);
      // this._iconGeometry.setCoordinates(oo);
      this.map.getView().setCenter(oo);

      this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

      if (this.map.getView().getZoom() > 21) {
        this.map.getView().setZoom(21);
      }

      if (this._vectorLayer) {
        this._vectorLayer.setSource(
          new ol.source.Vector({
            features: listPoint,
          })
        );
      } else {
        this._vectorLayer = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new ol.style.Stroke({
              color: "#00FFFF",
              width: 6,
            }),
            image: new ol.style.Circle({
              radius: 7,
              fill: new ol.style.Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.getLayers().push(this._vectorLayer);
      }
    }
  };

  //--------------------change ban do--------------------//
  onChangeBanDoSo(value, type) {
    switch (type) {
      case "BanDo":
        this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(false);
        this.BaseLayer.Google_Layer_Ban_Do.setVisible(value);
        this.setState({
          checkedBanDo: value,
          checkedVeTinh: false,
        });
        break;

      case "VeTinh":
        this.BaseLayer.Google_Layer_Ve_Tinh.setVisible(value);
        this.BaseLayer.Google_Layer_Ban_Do.setVisible(false);
        this.setState({
          checkedBanDo: false,
          checkedVeTinh: value,
        });
        break;
    }
  }

  //--------------------==========--------------------//
  getMyLocation() {
    const location = window.navigator && window.navigator.geolocation;
    if (location) {
      location.getCurrentPosition(
        (position) => {
          let data = {
            toaDoX: position.coords.longitude,
            toaDoY: position.coords.latitude,
            myLocation: true,
          };

          // this.jumpToLocation(data);
          let oo = ol.proj.transform(
            [parseFloat(data.toaDoX), parseFloat(data.toaDoY)],
            "EPSG:4326",
            "EPSG:3857"
          );
          this.setLocation(oo, 19);
          this.BaseLayer.vectorLayer.setVisible(true);
        },
        (error) => {
          message.error("Không thể xác định vị trí");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: Infinity,
        }
      );
    }
  }

  render() {
    return (
      <div id="do-an-quy-hoach" className="map-quy-hoach">
        <div className="map-bound " id="map-bound">
          <div id="map" className="map quy-hoach-ol-map" ref="map ">
            <button
              className="button-location btn-geo-on-map map-control-button"
              onClick={() => {
                this.getMyLocation();
              }}
            >
              <i className="fas fa-location-arrow"></i>
            </button>

            <Dropdown
              overlay={
                <Menu className="menu-layer">
                  <Menu.Item key="VeTinh">
                    <div className="fl-bw">
                      <div className="text">Vệ tinh</div>
                      <Switch
                        checked={this.state.checkedVeTinh}
                        onChange={(value) => {
                          this.onChangeBanDoSo(value, "VeTinh");
                        }}
                      ></Switch>
                    </div>
                  </Menu.Item>
                  <Menu.Divider />

                  <Menu.Item key="BanDo">
                    <div className="fl-bw">
                      <div className="text">Đường phố</div>
                      <Switch
                        checked={this.state.checkedBanDo}
                        onChange={(value) => {
                          this.onChangeBanDoSo(value, "BanDo");
                        }}
                      ></Switch>
                    </div>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <Tooltip title="Chuyển đổi nền" placement="bottomRight">
                <button className="button-layer map-control-button">
                  <i className="fas fa-map"></i>
                </button>
              </Tooltip>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  }
}

export default MapQuyHoach;
